/** TenantLayout içerik alanı — varsayılan koyu zemin yerine panel ile uyumlu açık zemin */
export const tenantPanelContentSx = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  backgroundColor: "#ffffff",
  px: { xs: 2, md: 3 },
  py: { xs: 3, md: 4 },
};
